<template>
  <div class="hot-analyze">
    <div class="center">
      <div class="choose-option">
        <div class="choose-title">用户来源</div>
        <el-select v-model="userSearch.origin" placeholder="请选择文字或电话" clearable @change="getUserList">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="userTime" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="timestamp" :clearable="false" :default-time="['00:00:00', '23:59:59']"
          @change="(e) => handleChange(e, 'userSearch')">
        </el-date-picker>
      </div>
      <div class="echarts-container">
        <div class="echarts-center">
          <div class="title title-class">来访省区域分布</div>
          <div id="chart3"></div>
        </div>
        <div class="echarts-center">
          <div class="title title-class">
            <span>来访市区域分布</span>
            <el-dropdown @command="(e) => getUserList(e)" trigger="click">
              <span class="el-dropdown-link title-class">
                {{ userSearch.province
                }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="my-dropdown">
                <el-dropdown-item v-for="(item, index) in provinceOpt" :key="index" :command="item.province">{{
                  item.province }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div id="chart4"></div>
        </div>
      </div>
    </div>
    <!-- <div class="line"></div>
    <div class="center">
      <div class="choose-option">
        <div class="choose-title">来访次数</div>
        <el-select
          v-model="visitSearch.origin"
          placeholder="请选择文字或电话"
          clearable
          @change="getList"
        >
          <el-option
            v-for="item in statusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="visitTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :clearable="false"
          :default-time="['00:00:00', '23:59:59']"
          @change="(e) => handleChange(e, 'visitSearch')"
        >
        </el-date-picker>
      </div>
      <div id="chart2"></div>
    </div> -->
    <div class="line"></div>
    <div class="center">
      <div class="choose-option">
        <div class="choose-title">热门资询</div>
        <el-select placeholder="请选择文字或电话" v-model="hotSearch.origin" @change="getHotList">
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="hotTime" type="daterange" range-separator="至" start-placeholder="开始日期"
          end-placeholder="结束日期" value-format="timestamp" :clearable="false" :default-time="['00:00:00', '23:59:59']"
          @change="(e) => handleChange(e, 'hotSearch')">
        </el-date-picker>
      </div>
      <div id="chart1"></div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import { ROBOT_TEXT, ROBOT_STATUS } from '@/utils/const'
import {
  getProvince,
  getVisitCount,
  getUserOrigin,
  getHotMessage,
} from '@/api/dataView'
export default {
  data() {
    return {
      statusOptions: [
        {
          value: ROBOT_STATUS.robotStatus,
          label: ROBOT_TEXT.robot,
        },
        {
          value: ROBOT_STATUS.textStatus,
          label: ROBOT_TEXT.text,
        },
      ],
      userSearch: {
        origin: '',
        start_time: '',
        end_time: '',
        province: '',
      },
      hotSearch: {
        origin: '',
        start_time: '',
        end_time: '',
      },
      visitSearch: {
        origin: '',
        start_time: '',
        end_time: '',
      },
      userTime: '',
      hotTime: '',
      visitTime: '',
      cityList: [],
      provinceList: [],
      provinceOpt: [],
      currentProvince: '',
      hotList: [],
      myChart1: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
    }
  },
  mounted() {
    this.getList()
    this.getProvince()
    this.getUserList()
    this.getHotList()
  },
  methods: {
    async getProvince() {
      const res = await getProvince()
      this.provinceOpt = res.data.provinceList
    },
    async getList() {
      const res = await getVisitCount({ ...this.visitSearch })
      let data1 = ['1-3次', '4-10次', '11-15次', '15-20次', '20次以上']
      let data2 = Object.values(res.data)
      this.initChart1('chart2', data1, data2, 'myChart2')
    },
    async getUserList(e) {
      if (e) {
        this.userSearch.province = e
      }
      const res = await getUserOrigin({ ...this.userSearch })
      this.userSearch.province = res.data.province
      this.cityList = res.data.cityList.map((item) => {
        item.value = item.count
        item.name = item.city + `(${item.ratio}%)`
        return item
      })
      this.provinceList = res.data.provinceList.map((item) => {
        item.value = item.count
        item.name = item.province + `(${item.ratio}%)`
        return item
      })
      this.initChart('chart3', this.provinceList, 'myChart3')
      this.initChart('chart4', this.cityList, 'myChart4')
    },
    async getHotList() {
      const res = await getHotMessage({ ...this.hotSearch })

      this.hotList = res.data
      let data1 = this.hotList.map((item) => item.intent_name)
      let data2 = this.hotList.map((item) => item.count)
      this.initChart1('chart1', data1, data2, 'myChart1')
    },
    isExist(myChart) {
      if (myChart != null && myChart != '' && myChart != undefined) {
        myChart.dispose()
      }
    },
    initChart(type, data, myChart) {
      this.isExist(this[myChart])
      this[myChart] = echarts.init(document.getElementById(type))
      // 绘制图表
      this[myChart].setOption({
        tooltip: {
          trigger: 'item',
        },
        series: [
          {
            type: 'pie',
            data,
            radius: '60%',
          },
        ],
      })
      setTimeout(() => {
        window.addEventListener(
          'resize',
          () => {
            this[myChart].resize()
          },
          { passive: true }
        )
      }, 500)
    },
    initChart1(type, data1, data2, myChart) {
      this.isExist(this[myChart])
      this[myChart] = echarts.init(document.getElementById(type))
      // 绘制图表
      this[myChart].setOption({
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          containLabel: true,
          left: '3%',
          right: '4%',
          bottom: '3%',
        },
        xAxis: {
          type: 'value',
          minInterval: 1,
        },
        yAxis: {
          type: 'category',
          data: data1,
          inverse: true,
        },
        series: [
          {
            name: type == 'chart2' ? '来访次数' : '热门资询',
            type: 'bar',
            data: data2,
            itemStyle: {
              color: type == 'chart2' ? '#67C23A' : '#5c7bd9',
            },
          },
        ],
      })
      setTimeout(() => {
        window.addEventListener(
          'resize',
          () => {
            this[myChart].resize()
          },
          { passive: true }
        )
      }, 500)
    },
    handleChange(e, type) {
      if (e == null) {
        this[type] = {
          ...this[type],
          start_time: '',
          end_time: '',
        }
      } else {
        this[type] = {
          ...this[type],
          start_time: parseInt(e[0]) / 1000,
          end_time: parseInt(e[1]) / 1000,
        }
      }
      switch (type) {
        case 'userSearch': {
          this.getUserList()
          break
        }
        case 'hotSearch': {
          this.getHotList()
          break
        }
        case 'visitSearch': {
          this.getList()
          break
        }
      }
    },
  },
}
</script>
<style lang="scss">
.hot-analyze {
  display: flex;
  flex-direction: column;
  align-items: center;

  .choose-option {
    display: flex;
    align-items: center;
  }

  .choose-title {
    flex-shrink: 0;
    font-size: 20px;
    color: #333;
    font-weight: 700;
  }

  .el-select {
    margin: 0 20px 0 20px;
    width: 315px;
    //   height: 35px;
  }

  .line {
    margin: 20px 0;
    width: 100%;
    height: 1px;
    background-color: #797979;
  }

  .echarts-container {
    margin-top: 30px;
    display: flex;
    justify-content: space-around;
  }

  #chart1,
  #chart2 {
    width: 100%;
    height: 400px;
  }

  #chart3,
  #chart4 {
    width: 100%;
    height: 300px;
  }

  .title-class {
    font-size: 14px;
    font-weight: 700;
    color: #333;
  }

  .echarts-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;

    .el-dropdown-link {
      margin-left: 6px;
      color: #409eff;
      cursor: pointer;
    }
  }
}

.my-dropdown {
  height: auto;
  max-height: 200px;
  border: none;
  overflow-y: scroll;
}

.my-dropdown::-webkit-scrollbar {
  width: 0;
}
</style>
